// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Login_pageWrapper__1U0bH","background":"Login_background__UX6m3"};